import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { Spinner, SpinnerSize } from '@fluentui/react';

export const AdsStudioSpinner = ({
  useCustomSize,
  className,
  customStyle,
}) => {
  const spinnerStyles = useMemo(() => ({
    circle: useCustomSize ? { width: 50, height: 50 } : null,
    root: customStyle || {
      width: '100%',
      height: '100%',
      margin: 'auto',
    },
  }), [customStyle, useCustomSize]);

  return (
    <Spinner
      size={SpinnerSize.large}
      styles={spinnerStyles}
      className={className}
    />
  );
};


AdsStudioSpinner.propTypes = {
  customStyle: PropTypes.shape({}),
  useCustomSize: PropTypes.bool,
  className: PropTypes.string,
};

AdsStudioSpinner.defaultProps = {
  useCustomSize: false,
  className: '',
  customStyle: null,
};
